export const SUPPORTED_CARDS = {
  amex: 'AMEX',
  mastercard: 'MasterCard',
  visa: 'VISA',
};
export const CURRENCIES = {
  GBP: 'GBP',
  EUR: 'EUR',
};

export const CURRENCY_SYMBOLS = {
  [CURRENCIES.GBP]: '£',
  [CURRENCIES.EUR]: '€',
};

export const DNA_CLIENT_NAME = 'Speedy_PDQ';
